import Bugsnag from "@bugsnag/js";
import { DispatchNotificationAction } from "@States/notifications";
import { ApiV2ErrorResponse } from "@Types/api/error";
import { FormError } from "@Types/error";

export const apiV2ErrorManager = (
  error: ApiV2ErrorResponse,
  dispatchUserNotification?: DispatchNotificationAction
): void => {
  const errorCode = error.response.data.error.error_code;
  const errorUserMessage = error.response.data.error.user_message;

  if (!errorUserMessage) {
    Bugsnag.notify({
      message: error.response.data.error.developer_message || errorCode,
      name: errorCode,
    });
  }

  if (!!dispatchUserNotification) {
    // TODO: notification system has to be refacto not to have a white list of error codes and accept any back error code
    errorUserMessage
      ? dispatchUserNotification({
          code: "CFE-001", // Force this front error code to avoid throwing error with back error code
          message: errorUserMessage,
          type: "addNotificationByCode",
        })
      : dispatchUserNotification({
          code: "CFE-001",
          type: "addNotificationByCode",
        });
  }
};

// TODO: function for api v1, remove when all api calls will be v2
export const errorManager = (
  dispatchNotification: DispatchNotificationAction,
  errorCode: string,
  errorMessage?: string | undefined
): void => {
  if (errorMessage) {
    dispatchNotification({
      code: errorCode,
      message: errorMessage,
      type: "addNotificationByCode",
    });
  } else {
    dispatchNotification({
      code: errorCode,
      type: "addNotificationByCode",
    });
  }

  // Avoid notify to bugsnag front errors that are not bugs
  if (
    errorCode !== "CFE-002" &&
    errorCode !== "CFE-003" &&
    errorCode !== "CFE-004" &&
    errorCode !== "CFE-005" &&
    errorCode !== "CFE-006" &&
    errorCode !== "CFE-007" &&
    errorCode !== "CFE-008"
  ) {
    Bugsnag.notify({ message: errorMessage || errorCode, name: errorCode });
  }
};

export const getFormErrorMessages = (
  errors: FormError[],
  withInputErrorMessages: boolean
): string =>
  errors.reduce((errorMessages, obj) => {
    // Get all FormError messages
    if (withInputErrorMessages) {
      return errorMessages !== "" ? `${errorMessages} ${obj.message}` : `${obj.message}`;
    } else {
      // Get only the FormError messages not linked to a form input
      return !!obj.input
        ? `${errorMessages}`
        : errorMessages !== ""
        ? `${errorMessages} ${obj.message}`
        : `${obj.message}`;
    }
  }, "");

export const getInputErrorMessages = (errors: FormError[], value: string): string =>
  getFormErrorMessages(
    errors.filter((error) => error.input === value),
    true
  );
